import * as types from './mutations-types'

const mutations = {
  [types.UPDATELOADINGSTATUS] (state, payload) {
    state.isLoading = payload.isLoading
  },
  [types.UPDATEDIRECTION] (state, payload) {
    state.direction = payload.direction
  },
  [types.UPDATEUSER] (state, payload) {
    state.user.id = payload.id
    state.user.userName = payload.userName
    state.user.postName = payload.postName
    state.user.location = payload.location
    state.user.clientCode = payload.clientCode
  },
  [types.UPDATETITLE] (state, payload) {
    state.mainTitle = payload
  },
  [types.UPDATECLIENT] (state, payload) {
    state.client = payload
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js